require('froala-editor/js/froala_editor.pkgd.min.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')
import 'froala-editor/js/plugins.pkgd.min'
import vuetify from '@/plugins/vuetify'

import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store/store'
import i18n from '@/assets/js/$/i18n'
import vuelidate from '@/assets/js/$/vuelidate'
import VueFroala from 'vue-froala-wysiwyg'
import './registerServiceWorker'
import Rollbar from 'rollbar';

import '@/assets/js/global/plugins/mediaquery'
import '@/assets/js/global/plugins/tooltip'
import '@/assets/js/global/plugins/imageUploader'

import '@/assets/js/global/components/icons'

Vue.config.productionTip = false

Vue.use(VueFroala)

Vue.prototype.$rollbar = new Rollbar({
  accessToken: (process.env.VUE_APP_ROLLBAR || process.env.VUE_APP_ROLLBAR_BUILDIN),
  captureUncaught: true,
  captureUnhandledRejections: true,
  reportLevel: 'debug',
  payload: {
    environment: process.env.NODE_ENV,
    code_version: '2.0.0',
  }
});

Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};


new Vue({
  vuetify,
  i18n,
  router,
  store,
  vuelidate,
  render: h => h(App)
}).$mount('#app')
